export default "__VITE_PUBLIC_ASSET__eeb71801__"